module.exports = __webpack_public_path__ + "img/animated-screen-1.153907b5.svg";